

    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {PaymentDetailsProps} from "@/features/applications/components/requirements/stateFee/StateFeeComponentProps";
    import TransferPaymentInfo from "@/features/applications/components/requirements/stateFee/TransferPaymentInfo.vue";
    import ExemptionPaymentInfo from "@/features/applications/components/requirements/stateFee/ExemptionPaymentInfo.vue";
    import OnSitePaymentInfo from "@/features/applications/components/requirements/stateFee/OnSitePaymentInfo.vue";
    import {
    ApplicationViewModel,
    factory,
    PaymentViewModel,
    StateFeeRequirementViewModel
    } from "@/api-client";
    import StateFeeInfoCard from "@/features/applications/components/requirements/stateFee/StateFeeInfoCard.vue";
    import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

    @Component({
    components: {
        TransferPaymentInfo,
        OnSitePaymentInfo,
        ExemptionPaymentInfo,
        StateFeeInfoCard,
        ButtonWithConfirm
    }
    })
    export default class PaymentDetails extends Vue {
        @Prop({ required: true })
        props!: PaymentDetailsProps;

        @Prop()
        removePaymentConfirmationAction!: () => Promise<void>;

        payment: PaymentViewModel = factory.create(PaymentViewModel);
        requirement!: StateFeeRequirementViewModel;
        application!: ApplicationViewModel; // TODO: Constrain this.

        paymentInfoComponentName: string | null = null;

        created() {
            this.payment = this.props.payment ?? factory.create(PaymentViewModel); // TODO(KJ)
            this.requirement = this.props.requirement;
            this.application = this.props.application;

            this.setPaymentInfoComponentName();

            this.$watch(
                () => this.props.payment,
                (payment) => {
                    this.payment = payment ?? factory.create(PaymentViewModel); // TODO(KJ)
                    this.setPaymentInfoComponentName();
                }
            );
        }

        setPaymentInfoComponentName() {
            const paymentMethod = this.payment.chosenMethod.paymentMethod;
            if (paymentMethod === "Transfer") 
            this.paymentInfoComponentName = "TransferPaymentInfo";
            
            if (paymentMethod === "OnSite")
            this.paymentInfoComponentName = "OnSitePaymentInfo";
            
            if (paymentMethod === "Exemption")
            this.paymentInfoComponentName = "ExemptionPaymentInfo";
        }

        get paymentConfirmed() {
            return this.payment.isConfirmed;
        }

        get paymentRefunded() {
            return this.payment.isRefunded;
        }
        
        get showRefundAndReturnCTA() {
          return !this.paymentRefunded && this.props.showRefundCTA;
        }

        async removePaymentConfirmation() {
            await this.removePaymentConfirmationAction();
        }
    }
